import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AuthService} from '../../core/security/auth.service';
import { MatDialogRef, MatDialogTitle, MatDialogClose, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { FlexModule } from '@angular/flex-layout';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';

@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    styleUrls: ['./logout.component.scss'],
    standalone: true,
    imports: [MatDialogTitle, FlexModule, MatIconButton, MatDialogClose, MatIcon, CdkScrollable, MatDialogContent, MatDialogActions, MatButton]
})
export class LogoutComponent implements OnInit {

  constructor(private router: Router, private authService: AuthService,
              public dialogRef: MatDialogRef<LogoutComponent>) {
  }

  ngOnInit() {
  }

  async onLogout() {
    await this.authService.logout(true);
    this.dialogRef.close(true);
  }
}
